import Vue from 'vue'
// https://github.com/kazupon/vue-i18n
import VueI18n from 'vue-i18n'
// https://github.com/moimikey/locale2
import browserLocale from 'browser-locale'
// https://github.com/marcuswestin/store.js/
import storeJs from 'store'
import messages from './messages'

Vue.use(VueI18n)

const dateTimeFormats = {
  'en': {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    }
  },
  'fr': {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric'
    }
  }
}

const numberFormats = {
  'en': {
    percent: {
      style: 'percent'
    }
  },
  'fr': {
    percent: {
      style: 'percent'
    }
  }
}

function bestLocale() {
  let locale = storeJs.get('cr:locale')
  if (locale) {
    return locale
  }
  const bl = browserLocale()
  if (bl) {
    return bl.split('-')[0]
  }
  return 'fr'
}
const i18n = new VueI18n({
  locale: bestLocale(),
  fallbackLocale: 'fr',
  // silentTranslationWarn: process.env.NODE_ENV === 'production',
  silentTranslationWarn: true,
  messages,
  dateTimeFormats,
  numberFormats
})

export default i18n
